import type { DragEvent } from 'react';
import { paletteItems, isTablerIconClass } from '../model/nodeTypes/registry';

// Safari/WebKit silently returns "" from dataTransfer.getData() for custom
// (non-standard) MIME types on drop — no error, the drop just no-ops. Using
// the standard 'text/plain' type keeps this working across all browsers.
// (Safe against unrelated text drags: addNodeAt() no-ops on any string that
// isn't a registered node type.)
export const PALETTE_DND_TYPE = 'text/plain';

export function Palette() {
    const onDragStart = (event: DragEvent<HTMLDivElement>, type: string) => {
        event.dataTransfer.setData(PALETTE_DND_TYPE, type);
        event.dataTransfer.effectAllowed = 'copy';
    };

    return (
        <div className="menu-section px-2 mb-3">
            <div className="hr-text text-secondary text-uppercase text-xs font-weight-bold mt-2 mb-2">Nodes</div>
            {paletteItems.map((item) => (
                <div
                    key={item.type}
                    className="submenu-item nav-link"
                    draggable
                    onDragStart={(event) => onDragStart(event, item.type)}
                >
                    {isTablerIconClass(item.icon) ? (
                        <i className={`ti ${item.icon} me-2`} />
                    ) : (
                        <span className="me-2">{item.icon}</span>
                    )}{' '}
                    {item.label}
                </div>
            ))}
        </div>
    );
}
